/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Order_Payment_ErrorInputs */

const vi_toast_order_payment_error = /** @type {(inputs: Toast_Order_Payment_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi nhận thanh toán thất bại`)
};

/**

* @param {Toast_Order_Payment_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_order_payment_error = /** @type {((inputs?: Toast_Order_Payment_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Order_Payment_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_order_payment_error(inputs)
});